<big-ui-table [renderResponsive]="true"
              [reOrderOnMobile]="false"
              [disableEvenOdd]="true"
              [rows]="tableRows()" />
